<template>
    <section class="transaction-history py-4">
    	<div class="page-container">
        	<div class="heading mb-5">
            	<h3 class="heading__h3 left text-black mBot10">Your Redemption History</h3>
                <div v-if="showViewAllButton" class="right">
                    <a href="/transaction_details" class="button pink smallsize mid caps">View All</a>
                </div>
                <div v-if="showOptions" class="right" style="width: 20%">
                    <select @change="onChange($event)" name="lstYears" class="form-select fs-3 shadow border-0 p-3 pe-5 rounded-10 bg-opacity-25" id="lstYears">
                        <option :selected="(index==0) ? 'selected' : false" v-for="(option, index) in optionsList" :key="index"> {{option}} </option>
                    </select>
                </div>
            </div>
            <div class="table-responsive">
                <div class="tableBlock no-shadow">
                    <table width="100%" border="0" cellpadding="0" cellspacing="0" class="table">
                        <thead>
                            <tr>
                                <th width="30%" class="text-left">Date</th>
                                <th width="20%" class="text-left">Merchant</th>
                                <th width="30%" class="text-left">Offer</th>
                                <th width="20%">Statement Credit Earned</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="transaction in transactions" :key="transaction.id">
                                <td data-th="Date" class="text-left">{{transaction.redeemedDate || ''}}</td>
                                <td data-th="Merchant Name" class="text-left">{{transaction.merchant_name || ''}}</td>
                                <td data-th="Name of Offer" class="text-left">{{transaction.title || ''}}</td>
                                <td data-th="Cash Earned">{{transaction.totalCashRedeemed || ''}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="!hidePagination" class="paginationBlock">
                <div class="pagination no-padding">
                    <a href="javascript:;" @click="onNextOrPrev('prev')" class="button pink smallsize small caps" v-if="currentPage > 1 && totalPages > 1">&#8249; Prev</a>
                    <div v-if="totalCount" class="page-info">
                        Page {{currentPage}} of {{totalPages}}
                    </div>
                    <a href="javascript:;" style="text-decoration: none" @click="onNextOrPrev('next')" class="button pink smallsize small caps" v-if="currentPage < totalPages && totalPages > 1">Next &#8250;</a>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
import PaginationComponent from './PaginationComponent.vue'
export default {
    components: { PaginationComponent },
    name: "TransactionHistoryComponent",
    props: ['hidePagination', 'applyLimit', 'order', 'showViewAllButton', 'showOptions'],
    data() {
        return {
            transactions: [],
            currentPage: 1,
            // nextPage: 2,
            totalCount: 0,
            totalPages: 0,
            itemsPerPage: 10,
            optionsList: {'all': 'All', 'week' : 'This Week', 'month' : 'This Month', 'year' : 'This Year'},
            currentSelectedOption: 'All'
        }
    },
    methods: {
        onChange(event) {
            if(event.target.value) {
                this.currentSelectedOption = event.target.value;
                this.currentPage = 1; // reset page value

                this.getTransactionHistory({
                    page: this.currentPage - 1,
                    limit: this.itemsPerPage,
                    period: this.currentSelectedOption
                })
            }
        },
        onNextOrPrev(step) {

            if(step == 'next') {
                let curPage = this.currentPage;
                if(this.currentPage < this.totalPages) {
                    this.currentPage = curPage + 1;
                }
            } else {
                let curPage = this.currentPage;
                this.currentPage = (curPage > 1) ? (curPage - 1) : 1;
            }

            if(this.totalCount > 0 ) {
                this.getTransactionHistory({
                    page: this.currentPage - 1,
                    limit: this.itemsPerPage,
                    period: this.currentSelectedOption
                })
            }
        },

        getTransactionHistory(payload) {
            axios.get(this.apiEndPoints.getTransactionHistory, {params:payload})
                .then((response) => {

                    if(response.data && response.data) {
                        this.transactions = response.data.transactions || [];
                        this.totalCount = response.data.totalCount || 0;
                        this.totalPages = response.data.totalPages || 0;
                    }


                })
                .catch((error) => {
                    // console.error(error, 'here');
                    // console.error(error.status,'here')

                    if (error.response.status == 401 || error.response.status == 419) {
                        this.$router.push({ name: 'sign_in' });
                    }
                }).finally(() => {

            });
        }
    },

    mounted() {

        let payload  = {
            page: this.currentPage - 1,
            limit: this.itemsPerPage,
            period: this.currentSelectedOption
        };

        if(this.applyLimit) {
            payload.limit = this.applyLimit;
        }

        if(this.order && this.order == 'desc') {
            payload.order_by = this.order;
        }

        this.getTransactionHistory(payload);
    }
}
</script>
